import React, { useEffect, useState, useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

// Confetti Component
function Confetti() {
  const colors = ['#3D3D8C', '#10b981', '#F59E0B', '#EF4444', '#6B6BBF', '#FF6B6B', '#4ECDC4', '#FFE66D'];
  const confettiCount = 150;

  const confettiPieces = Array.from({ length: confettiCount }, (_, i) => {
    const style = {
      left: `${Math.random() * 100}%`,
      animationDelay: `${Math.random() * 2}s`,
      animationDuration: `${2 + Math.random() * 2}s`,
      backgroundColor: colors[Math.floor(Math.random() * colors.length)],
      width: `${8 + Math.random() * 8}px`,
      height: `${8 + Math.random() * 8}px`,
      borderRadius: Math.random() > 0.5 ? '50%' : '2px',
      transform: `rotate(${Math.random() * 360}deg)`,
    };
    return <div key={i} className="confetti" style={style} />;
  });

  return <div className="confetti-container">{confettiPieces}</div>;
}

function AvaliacaoSucesso() {
  const location = useLocation();
  const navigate = useNavigate();
  const { positiva, googleReviewLink, nome } = location.state || {};
  const [countdown, setCountdown] = useState(3);
  const [redirected, setRedirected] = useState(false);

  const openGoogleReview = useCallback(() => {
    if (googleReviewLink && !redirected) {
      setRedirected(true);
      window.open(googleReviewLink, '_blank');
    }
  }, [googleReviewLink, redirected]);

  useEffect(() => {
    if (!location.state) {
      navigate('/');
      return;
    }

    // Auto redirect for positive reviews
    if (positiva && googleReviewLink) {
      const timer = setInterval(() => {
        setCountdown(prev => {
          if (prev <= 1) {
            clearInterval(timer);
            openGoogleReview();
            return 0;
          }
          return prev - 1;
        });
      }, 1000);

      return () => clearInterval(timer);
    }
  }, [location.state, navigate, positiva, googleReviewLink, openGoogleReview]);

  if (!location.state) {
    return null;
  }

  return (
    <div>
      {/* Confetti for positive reviews */}
      {positiva && <Confetti />}

      {/* Header */}
      <header className="header">
        <div className="header-top">
          <a href="https://hospitalunique.com.br" target="_blank" rel="noopener noreferrer">Visite nosso site</a>
        </div>
        <div className="header-main">
          <img src="/logo.jpg" alt="Hospital Unique" className="header-logo" />
          <div className="header-title">
            <h1>Pesquisa de Satisfação</h1>
            <p>Obrigado por participar!</p>
          </div>
        </div>
      </header>

      <div className="container">
        <div className="card">
          <div className="success-container">
            {positiva ? (
              <>
                <div className="success-icon">🎉</div>
                <h2>Muito obrigado, {nome}!</h2>
                <p>
                  Ficamos muito felizes com sua avaliação positiva!<br />
                  Sua opinião nos motiva a continuar oferecendo o melhor atendimento.
                </p>

                <div className="google-review-box">
                  <h3>Sua opinião pode ajudar outras pessoas!</h3>
                  <p>
                    Que tal compartilhar sua experiência também no Google?<br />
                    Sua avaliação ajuda outras pessoas a conhecerem nosso trabalho.
                  </p>

                  <button
                    className="btn btn-lg"
                    onClick={openGoogleReview}
                    style={{ marginTop: '10px' }}
                  >
                    ⭐ Avaliar no Google
                  </button>

                  {countdown > 0 && !redirected && (
                    <p className="countdown">
                      Abrindo avaliação do Google em {countdown} segundo{countdown !== 1 ? 's' : ''}...
                    </p>
                  )}

                  {redirected && (
                    <p className="countdown">
                      ✓ Página do Google aberta em nova aba
                    </p>
                  )}
                </div>

                <p style={{ color: 'var(--text-secondary)', fontSize: '0.95rem', marginTop: '25px' }}>
                  Enviamos uma mensagem para seu WhatsApp com o link de avaliação.
                </p>
              </>
            ) : (
              <>
                <div className="success-icon">💙</div>
                <h2>Obrigado pelo seu feedback, {nome}!</h2>
                <p>
                  Agradecemos por dedicar seu tempo para nos avaliar.<br />
                  Sua opinião é muito importante e nos ajudará a melhorar nossos serviços.
                </p>
                <p style={{ color: 'var(--text-secondary)', marginTop: '20px' }}>
                  Nossa equipe analisará suas respostas com atenção<br />
                  e trabalhará para oferecer uma experiência ainda melhor.
                </p>
              </>
            )}

            <div style={{ marginTop: '45px' }}>
              <button
                className="btn btn-outline"
                onClick={() => navigate('/')}
              >
                Voltar ao início
              </button>
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="footer-info">
          <img src="/logo.jpg" alt="Hospital Unique" />
          <p style={{ fontWeight: '600', marginBottom: '5px' }}>Hospital Unique</p>
          <p>Cuidando de você com excelência</p>
        </div>
      </div>
    </div>
  );
}

export default AvaliacaoSucesso;
